import _ from 'lodash';
import { t } from '@lingui/macro';
import {
    USER_SOURCE_LDAP,
    USER_SOURCE_NG1,
    USER_SOURCE_NGP,
    USER_SOURCE_NGP_DEFAULT,
    USER_SOURCE_SAML,
} from './UserConstants';

export const PASSWORD_MISMATCH_ERROR_TEXT = t`Password and Confirm Password values do not match`;

export function doPasswordsMatch(password, confirmPassword) {
    if (!_.isEmpty(password) && !_.isEmpty(confirmPassword)) {
        // If they don't match force the error.
        if (password !== confirmPassword) {
            return false;
        }
    }

    return true;
}

export function shouldDisableStatusAndRole(user, userCount) {
    const lockUserTotalCount = 1;
    const userSource = getUserSource(user);
    // We want to disable status and roll if we only have one user or if this is managed by nG1
    return userSource === USER_SOURCE_NG1 || userCount === lockUserTotalCount;
}

export function shouldDisableName(user) {
    const userSource = getUserSource(user);
    // For SAML users, just in the case the mapping is wrong (or not mappable) we
    //  will allow them to change the name
    return userSource === USER_SOURCE_LDAP || userSource === USER_SOURCE_NG1;
}

export function shouldDisableUsername(user) {
    const userSource = getUserSource(user);
    return userSource !== USER_SOURCE_NGP && userSource !== USER_SOURCE_NGP_DEFAULT;
}

export function shouldDisableTimeZone(user) {
    const userSource = getUserSource(user);
    return userSource === USER_SOURCE_NG1;
}

export function shouldDisableEmail(user) {
    const userSource = getUserSource(user);
    return userSource !== USER_SOURCE_NGP && userSource !== USER_SOURCE_NGP_DEFAULT;
}

export function shouldShowPassword(user) {
    const userSource = getUserSource(user);
    return userSource !== USER_SOURCE_LDAP && userSource !== USER_SOURCE_SAML && userSource !== USER_SOURCE_NG1;
}

export function shouldShowSourceField(user) {
    const userSource = getUserSource(user);
    return userSource !== USER_SOURCE_NGP_DEFAULT && userSource !== USER_SOURCE_NGP;
}

function getUserSource(user) {
    return _.get(user, 'source');
}
